import * as common from "./DownloadSystemFile";

declare global {
    namespace common {
        const downloadSystemFile: (path: string) => void;
    }
}

window.common = window.common || {};
window.common = {
    ...window.common,
    ...common,
};
